// extracted by mini-css-extract-plugin
module.exports = {"sign_up_page":"index_sign_up_page__1i2qk","success_msg":"index_success_msg__2Vb4k"};